import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { chain } from 'lodash';
import isMobile from 'ismobilejs';
let MySelect = class MySelect extends Vue {
    get isMobile() {
        return isMobile(navigator.userAgent).any;
    }
    get events() {
        return chain(['input', 'change'])
            .keyBy()
            .mapValues(event => (payload) => this.$emit(event, payload))
            .value();
    }
};
MySelect = __decorate([
    Component
], MySelect);
export default MySelect;
